export const GA = 'G-JT9JD49TYM';
